import React, { useRef } from "react";

import { Drawer, Box, ModalProps, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HiOutlineChevronDoubleRight } from "react-icons/hi";

import { useActualInventoryContext } from "Hooks/useActualInventoryContext";
import { useOutsideAlerter } from "Hooks/useOutsideAlerter";
import useStyles from "./styles";

type Props = {
  open?: boolean;
  onClose?: ModalProps["onClose"];
};

const DrawerComments = (props: Props) => {
  const { open, onClose } = props;

  const { itemJob } = useActualInventoryContext();

  const classes = useStyles();

  const { t: translate } = useTranslation();

  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, () => onClose && onClose({}, "backdropClick"));

  const renderComment = () => {
    if (itemJob?.comments) {
      return (
        <Box className={classes.box}>
          <Typography
            color="#465869"
            fontFamily="Manrope"
            fontWeight={500}
            fontSize="14px"
            lineHeight="21px"
          >
            {itemJob?.comments}
          </Typography>
        </Box>
      );
    }

    return null;
  };

  return (
    <Drawer
      PaperProps={{ className: classes.paperProps }}
      anchor="right"
      open={open}
      onClose={onClose}
      hideBackdrop
      ModalProps={{ className: classes.modalProps }}
    >
      <Box ref={wrapperRef} minWidth="254px" padding="24px 16px">
        <Stack direction="row" justifyContent="space-between">
          <Typography
            color="#465869"
            fontFamily="Manrope"
            fontWeight={700}
            fontSize="16px"
            lineHeight="24px"
          >
            {translate("comments")}
          </Typography>
          <HiOutlineChevronDoubleRight
            onClick={() => onClose && onClose({}, "escapeKeyDown")}
            className={classes.icon}
          />
        </Stack>
        {renderComment()}
      </Box>
    </Drawer>
  );
};

export default DrawerComments;
